import _filter from 'lodash/filter';
import _find from 'lodash/find';
import _includes from 'lodash/includes';
import { LOCAL_STORAGE_PRESENTAION_USER_INFO_KEY } from '../constants';

type UserInfoType = {
  name?: string;
  pickedIds?: number[];
};

export const getPresentationUserInfo = (): UserInfoType => {
  const userDataFromLocalStorage = localStorage.getItem(LOCAL_STORAGE_PRESENTAION_USER_INFO_KEY);

  return (
    JSON.parse(userDataFromLocalStorage) || {
      name: '',
      pickedIds: [],
    }
  );
};

export const setPresentationUserInfo = ({ name, pickedIds }: UserInfoType): void => {
  localStorage.removeItem(LOCAL_STORAGE_PRESENTAION_USER_INFO_KEY);

  const userInfoToBeStored = {
    name,
    pickedIds: pickedIds || [],
  };

  localStorage.setItem(LOCAL_STORAGE_PRESENTAION_USER_INFO_KEY, JSON.stringify(userInfoToBeStored));
};

export const updatePresentationUserInfo = ({
  name,
  addedPick,
  deletedPick,
}: {
  name?: string;
  addedPick?: { id: number };
  deletedPick?: { id: number };
}): void => {
  const currentUserInfo = getPresentationUserInfo();
  let updatedPickedIds = currentUserInfo.pickedIds;

  if (addedPick) {
    updatedPickedIds = [addedPick.id, ...updatedPickedIds];
  }

  if (deletedPick) {
    updatedPickedIds = _filter(updatedPickedIds, (pickedId) => pickedId !== deletedPick.id);
  }

  setPresentationUserInfo({
    name: currentUserInfo.name || name,
    pickedIds: updatedPickedIds,
  });
};

export const getMyPick = (pickedBy: { id: number }[]) => {
  const userInfo = getPresentationUserInfo();

  return _find(pickedBy, (item) => _includes(userInfo.pickedIds, item.id));
};
